import React from 'react';
import { type SVGComponentProps } from '../../../../types/Svgs';

const SVGComponent: React.FC<SVGComponentProps> = ({ primaryColor, secondaryColor, size }) => {
  return (
    <div>
      <svg
        width={size != null ? size[0].toString() : '39'}
        height={size != null ? size[1].toString() : '39'}
        viewBox="0 0 39 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
          .primaryTram { fill: ${primaryColor != null ? primaryColor : '#4CAF50'} }
          .secondaryTram { fill: ${secondaryColor != null ? secondaryColor : 'grey'} }
        `}
        </style>
        <circle cx="19.3606" cy="19.3438" r="18.1865" className="primaryTram" stroke="white" strokeWidth="1.5" />
        <path
          d="M27.4945 23.0018C27.4945 21.9362 27.4455 20.8729 27.3476 19.8118L26.8451 14.3714C26.5187 11.8573 23.8689 10.7793 20.0346 10.6543V9.06944H22.9454C23.3059 9.06944 23.5981 8.76686 23.5981 8.39361C23.5981 8.02035 23.3059 7.71777 22.9454 7.71777H15.7662C15.4057 7.71777 15.1135 8.02035 15.1135 8.39361C15.1135 8.76686 15.4057 9.06944 15.7662 9.06944H18.7293V10.6745C14.8884 10.7523 12.2321 11.57 11.8764 14.3916L11.3738 19.7983C11.2716 20.8729 11.2215 21.9497 11.2237 23.0288V28.2631C11.2237 29.7561 12.3925 30.9665 13.8343 30.9665H24.8871C26.3289 30.9665 27.4977 29.7561 27.4977 28.2631L27.4945 23.0018ZM15.541 27.1108H13.2861C12.8752 27.0569 12.5672 26.6949 12.5672 26.266C12.5672 25.8371 12.8752 25.4752 13.2861 25.4212H15.541C15.9519 25.4752 16.26 25.8371 16.26 26.266C16.26 26.6949 15.9519 27.0569 15.541 27.1108ZM25.5691 27.1108H23.2848C22.8739 27.0569 22.5659 26.6949 22.5659 26.266C22.5659 25.8371 22.8739 25.4752 23.2848 25.4212H25.5691C25.98 25.4752 26.2881 25.8371 26.2881 26.266C26.2881 26.6949 25.98 27.0569 25.5691 27.1108ZM25.6572 22.9714H13.2241C13.0409 22.972 12.8659 22.893 12.7418 22.7535C12.6177 22.6141 12.5559 22.427 12.5714 22.2381L13.1654 14.9695C13.1654 14.2379 13.7381 13.6448 14.4446 13.6448H24.4172C25.1242 13.6448 25.6978 14.2374 25.6996 14.9695L26.2903 22.2482C26.3028 22.432 26.2423 22.6132 26.1228 22.7497C26.0033 22.8862 25.8351 22.9663 25.6572 22.9714Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default SVGComponent;
